<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="clearfix">
    <vs-input
      v-validate="'required|alpha_dash|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="First Name"
      name="first_name"
      placeholder="First Name"
      v-model="first_name"
      class="w-full"
    />
    <span class="text-danger text-sm"
      >{{ error["first_name"] }} {{ errors.first("first_name") }}</span
    >

    <vs-input
      v-validate="'required|alpha_dash|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Last Name"
      name="last_name"
      placeholder="Last Name"
      v-model="last_name"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm"
      >{{ error["last_name"] }} {{ errors.first("last_name") }}</span
    >

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label-placeholder="Email"
      placeholder="Email"
      v-model="email"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm"
      >{{ error["email"] }} {{ errors.first("email") }}</span
    >

    <vs-input
      v-validate="'required|numeric'"
      data-vv-validate-on="blur"
      name="phone"
      type="phone"
      label-placeholder="Phone Number (Username)"
      placeholder="Phone Number"
      v-model="phone"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm"
      >{{ error["username"] }} {{ errors.first("phone") }}</span
    >

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:10'"
      name="password"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm"
      >{{ error["password1"] }} {{ errors.first("password") }}</span
    >

    <vs-input
      type="password"
      v-validate="'min:6|max:10|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirm Password"
      placeholder="Confirm Password"
      v-model="confirm_password"
      class="w-full mt-6"
    />
    <span class="text-danger text-sm"
      >{{ error["password2"] }} {{ errors.first("confirm_password") }}</span
    >

    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-6"
      >I accept the terms & conditions.</vs-checkbox
    >
    <vs-button type="border" to="/pages/login" class="mt-6">Login</vs-button>
    <vs-button
      class="float-right mt-6"
      @click="registerUserJWt"
      :disabled="!validateForm"
      >Register</vs-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      password: "",
      confirm_password: "",
      referer: "",
      isTermsConditionAccepted: true,
      error: {},
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.first_name != "" &&
        this.last_name != "" &&
        this.email != "" &&
        this.phone != "" &&
        this.password != "" &&
        this.confirm_password != "" &&
        this.isTermsConditionAccepted === true
      );
    },
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });

        return false;
      }
      return true;
    },
    registerUserJWt() {
      // If form is not validated or user is already login return
      if (!this.validateForm || !this.checkLogin()) return;

      this.$vs.loading();

      const payload = {
        userDetails: {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          password: this.password,
          confirmPassword: this.confirm_password,
        },
        notify: this.$vs.notify,
      };
      this.error = {};
      this.$store
        .dispatch("auth/registerUserJWT", payload)
        .then((response) => {
          this.$vs.loading.close();
          if (response.data.errors) {
            this.error = response.data.errors;
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
